import { HttpClinet } from './../utils/config'

export const pdpaAPI = {
    getCompany: () => {
        return HttpClinet({
            url: `/prefix/getCompany`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    postCompany: (_id) => {
        return HttpClinet({
            url: `/prefix/getCompany`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: { _id }
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    submitPDPA: () => {
        return HttpClinet({
            url: `/prefix/submitPDPA`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    CompanyAll: (data) => {
        return HttpClinet({
            url: `/prefix/CompanyAll`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    DownloadFile: (data) => {
        return HttpClinet({
            url: `/prefix/ExcelCompany`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
            data: data
        })
            .then((response) => {
                return response
            })
            .catch((error) => {
                throw error
            })
    },
}